import {ReactComponent as WarningSVG} from '../../../img/icons/warning.svg';

const Error = ({msg}) => {
    return (
        <div className="error">
            <WarningSVG className="error_icon" />
            {msg ? msg : 'Something went wrong. Please try again later.'}
        </div>
    )
};

export default Error;
